import { useCallback, useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import {
  createLocaleDateFormatter,
  type FormatOptions,
} from '../utils/formatDateWithLocale';

const DEFAULT_FALLBACK = '—';

export function useLocaleDateFormatter() {
  const { locale } = useLocale();
  const localeFormatter = useMemo(
    () => createLocaleDateFormatter(locale),
    [locale]
  );

  const formatDisplayDate = useCallback(
    (
      value: Date | string | number | null | undefined,
      options?: FormatOptions
    ) => {
      if (value === null || value === undefined) {
        return options?.fallbackText ?? DEFAULT_FALLBACK;
      }
      return localeFormatter.formatDate(value, {
        fallbackText: DEFAULT_FALLBACK,
        ...options,
      });
    },
    [localeFormatter]
  );

  const formatDisplayDateTime = useCallback(
    (
      value: Date | string | number | null | undefined,
      options?: FormatOptions
    ) => {
      if (value === null || value === undefined) {
        return options?.fallbackText ?? DEFAULT_FALLBACK;
      }
      return localeFormatter.formatDateTime(value, {
        fallbackText: DEFAULT_FALLBACK,
        ...options,
      });
    },
    [localeFormatter]
  );

  return {
    formatDisplayDate,
    formatDisplayDateTime,
    localeFormatter,
  };
}
